import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreateCategoriesApi, DeleteCategoriesApi, GetCategoriesApi } from "../apis/CategoryApis";
import { showSnackbar } from "../slices/SnackbarSlice";

export const GetCategoriesAction = createAsyncThunk(
    "get/category",
    async (payload: string, { rejectWithValue }) => {
        try {
            const response = await GetCategoriesApi(payload)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data || { message: "failed to fetch" });
        }
    }
);


export const CreateCategoriesAction = createAsyncThunk(
    "create/category",
    async (payload: any, { rejectWithValue, dispatch }) => {
        try {
            const response = await CreateCategoriesApi(payload)
            dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to add", type: "error" }));

            return rejectWithValue(error?.response?.data || { message: "failed to add" });
        }
    }
);


export const DeleteCategoriesAction = createAsyncThunk(
    "delete/category",
    async (payload: any, { rejectWithValue, dispatch }) => {
        try {
            const response = await DeleteCategoriesApi(payload)
            dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to delete", type: "error" }));

            return rejectWithValue(error?.response?.data || { message: "failed to fetch" });
        }
    }
);
